
let dragTarget = {};
let dragContainer = {};

export function setDragging({user, container}) {
    dragTarget = user;
    dragContainer = container;
}
/*
group
name
members
*/
export function canMoveTo(container) {
  try {
    return (dragContainer.name) !== (container.name)
  } catch(ex) {
    return false
  }
}

let moveToCb = (dragTarget, dragContainer, container) => {
  console.log(dragTarget, dragContainer.name, "->", container.name)
  // dispatch(editUser({id: dragTarget.id, changes: {thanhPhan: container.name}}))
};
export function setMoveToCb(cb) {
  moveToCb = cb;
}

export function moveTo(container, dispatch) {
  moveToCb(dragTarget, dragContainer, container);
}

export function Overlay({ color }) {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        zIndex: 1,
        opacity: 0.5,
        backgroundColor: color,
      }}
    />
  );
}